<sb-loader />
<router-outlet />
